<div class="dashboard-container">

  <!-- Sección de bienvenida -->
  <div class="header">
    <div class="header-content">
      <div class="current-date">
        <span class="date-text">{{ currentDate | date:'EEEE d \'de\' MMMM \'del\' yyyy' }}</span>
      </div>
      <h1 class="welcome-title">Bienvenido {{ authUser.name }}</h1>
    </div>
  </div>

  <!-- Cards resumen: Desktop -->
  <div class="summary-cards desktop-cards">
    <!-- Card 1: Objetivo total -->
    <div class="summary-card" (click)="cardClick('objetivos')">
      <div class="card-icon">
        <img src="assets/icons/Component_1.svg" alt="Objetivo total" class="icon">
      </div>
      <div class="card-content">
        <h2 class="card-title">Objetivo total</h2>
        <div class="progress-container">
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="totalPorcentajeObjetivos"></div>
          </div>
          <p class="progress-text">Objetivos completados {{ totalObjetivosCompletados }} / {{ totalObjetivos }}</p>
        </div>
        <p class="action-link">Click para ver objetivos</p>
      </div>
    </div>

    <!-- Card 2: Hora de MENTOR -->
    <div class="summary-card" (click)="openHoursMentorModal()">
      <div class="card-icon">
        <img src="assets/icons/Component_2.svg" alt="Hora de MENTOR" class="icon">
      </div>
      <div class="card-content">
        <h2 class="card-title">Hora de MENTOR</h2>
        <div class="status-box">
          <p>{{ horasMentores }} hrs usadas de {{ horasTotalesMentores }} hrs compradas</p>
        </div>
        <p class="action-link">Click para comprar horas</p>
      </div>
    </div>

    <!-- Card 3: Hora de EXPERTO -->
    <div class="summary-card" (click)="cardClick('experto')">
      <div class="card-icon">
        <img src="assets/icons/Component_2.svg" alt="Hora de EXPERTO" class="icon">
      </div>
      <div class="card-content">
        <h2 class="card-title">Hora de EXPERTO</h2>
        <div class="status-box">
          <p>{{ horasExpertos }} hrs usadas de {{ horasTotalesExpertos }} hrs compradas</p>
        </div>
        <p class="action-link">Click para comprar horas</p>
      </div>
    </div>
  </div>

  <!-- Cards resumen: Mobile -->
  <div class="summary-cards mobile-cards">
    <!-- Card 1: Objetivos completados (Verde) -->
    <div class="mobile-summary-card green-card" (click)="cardClick('objetivos')">
      <div class="mobile-card-icon">
        <i class="fa-solid fa-trophy"></i>
      </div>
      <div class="mobile-card-content">
        <h3 class="mobile-card-title">Objetivos</h3>
        <p class="mobile-card-value">{{ totalObjetivosCompletados }}/{{ totalObjetivos }}</p>
      </div>
    </div>

    <!-- Card 2: Hora de experto (Púrpura) -->
    <div class="mobile-summary-card purple-card" (click)="openHoursMentorModal()">
      <div class="mobile-card-icon">
        <i class="fa-solid fa-lock"></i>
      </div>
      <div class="mobile-card-content">
        <h3 class="mobile-card-title">Hora de experto</h3>
        <p class="mobile-card-value">{{ horasExpertos }}/{{ horasTotalesExpertos }} </p>
      </div>
    </div>

    <!-- Card 3: Hora de mentor (Azul claro) -->
    <div class="mobile-summary-card light-blue-card" (click)="cardClick('mentor')">
      <div class="mobile-card-icon">
        <i class="fa-solid fa-clock"></i>
      </div>
      <div class="mobile-card-content">
        <h3 class="mobile-card-title">Hora de mentor</h3>
        <p class="mobile-card-value">{{ horasMentores }}/{{ horasTotalesMentores }}</p>
      </div>
    </div>
  </div>

  <!-- Banner Felicitaciones por salario alto -->
  <div *ngIf="showSalaryBanner" class="salary-banner">
    <div class="banner-content">
      <div class="banner-text">
        <h3>¡Felicidades!</h3>
        <p *ngIf="!isHighSalaryUser">Entre todas las personas inscritas, has sido <strong>preseleccionado</strong> para
          Professional.</p>
        <p *ngIf="isHighSalaryUser">
          Fuiste preseleccionado para Pheonix Executive, una experiencia diseñada para quienes buscan trascender.
          Conoce más de Pheonix executive
          <a href="https://phoenix.com.pe/personas/" target="_blank" rel="noopener noreferrer"
            class="banner-link">AQUI</a>.
        </p>
      </div>

      <button *ngIf="!isHighSalaryUser" class="banner-button" (click)="openWaitlistModal()">
        Únete a nuestra lista de espera
      </button>

      <button *ngIf="isHighSalaryUser" class="banner-button" (click)="scheduleInterviewFromBanner()">
        Agendar entrevista
      </button>

      <button class="banner-close" (click)="closeSalaryBanner()">
        ×
      </button>
    </div>
  </div>

  <!-- Mensaje cuando no hay objetivos -->
  <div *ngIf=" totalObjetivos === 0 " class="no-objectives-message">
    <div class="message-content">
      <span class="checkmark-icon">✓</span>
      <p class="message-text">
        Aún no tienes objetivos registrados. Empieza creando el primero y da el primer paso hacia tus metas.
      </p>
    </div>
  </div>

  <!-- Mensaje informativo (oculto por defecto, similar a ObjectivesComponent) -->
  <div *ngIf="!messageHide" class="message">
    <div class="message-text">
      <span class="icon-info"></span>
      <p>
        Completa la priorización con tu mentor para tener una mejor guía de qué
        objetivos crear.
      </p>
    </div>
    <div class="message-close" (click)="hideMessage()">
      <span class="icon-close">×</span>
    </div>
  </div>

  <!-- Botones de Objetivos -->
  <div class="objectives-header">
    <div class="header">
      <h2 class="title">Resumen de Objetivos</h2>
      <p class="description">Revisa aqui la lista de tus 5 últimos objetivos.</p>
    </div>
    <button class="btn-view-objectives" (click)="viewObjectives()">
      Ver objetivos
    </button>
  </div>

  <!-- Componente de Progreso, Objetivos y Actividades -->
  <app-table [data]="objetivosOriginales" [showFilters]="false" (itemDeleted)="onObjetivoDeleted($event)"
    (designResponsive)="onDesignResponsive($event)" (stateChanged)="onStateChanged()"
    (reloadObjectives)="reloadObjectivesList()"></app-table>

  <!-- Botón Resumen Compras-->
  <div class="purchase-summary-buttons">
    <button class="btn-view-purchases" (click)="openModalPurchaseSummary()">
      Ver resumen de compras
    </button>
  </div>

  <!-- Sección de Calendario -->
  <div class="calendario-card">
    <div class="card-header">
      <h2>Calendario</h2>
      <p style="color: #53545C; margin: 0;">Explora tu semana. Al hacer click en cada día, podrás ver tu agenda
        personalizada y las actividades planificadas.</p>
      <!-- Resumen de próximas citas -->
      <!-- <div class="upcoming-appointments">
        <h3>Próximas citas</h3>
        <div class="appointments-list" *ngIf="getUpcomingAppointments().length > 0">
          <div class="appointment-item" *ngFor="let appointment of getUpcomingAppointments()">
            <div class="appointment-info">
              <span class="appointment-date">{{ appointment.date | date:'dd/MM/yyyy' }}</span>
              <span class="appointment-time">{{ appointment.time }}</span>
              <span class="coach-name">{{ appointment.coach.name }}</span>
              <span class="coach-type">{{ appointment.coach.type.name }}</span>
            </div>
          </div>
        </div>
        <div class="no-appointments" *ngIf="getUpcomingAppointments().length === 0">
          <p>No tienes citas programadas</p>
          <button class="schedule-btn" (click)="goToMentors()">Agendar cita</button>
        </div>
      </div> -->
    </div>

    <div class="calendario-container">
      <div class="calendario-content">


        <!-- Calendario Mensual (Sidebar) - Solo visible en móvil -->
        <div class="calendario-mensual mobile-only">
          <div class="month-header">
            <div class="month-selector">
              <span class="month-year">{{ currentMonthYear }}</span>
              <span class="dropdown-arrow">▼</span>
            </div>
            <div class="month-nav">
              <button class="month-nav-btn" (click)="navigateMonth(-1)">&#8592;</button>
              <button class="month-nav-btn" (click)="navigateMonth(1)">&#8594;</button>
            </div>
          </div>

          <div class="mini-calendar">
            <div class="mini-calendar-header">
              <span>D</span>
              <span>L</span>
              <span>M</span>
              <span>M</span>
              <span>J</span>
              <span>V</span>
              <span>S</span>
            </div>
            <div class="mini-calendar-grid">
              <div class="mini-day" *ngFor="let dayData of miniCalendarDays; let i = index"
                [class.other-month]="dayData.isOtherMonth" [class.today]="dayData.isToday"
                [class.has-event]="dayData.hasEvent" [class.selected]="isSelectedDay(dayData)"
                (click)="selectMiniCalendarDay(dayData)">
                {{ dayData.day > 0 ? dayData.day : '' }}
              </div>
            </div>
          </div>

          <!-- <div class="filtro-calendario">
            <h4>Filtrar por</h4>
            <div class="filtro-botones">
              <button class="filter-btn">Personal</button>
              <button class="filter-btn">Trabajo</button>
              <button class="filter-btn">Estudios</button>
              <button class="filter-btn">Coaching</button>
            </div>
          </div> -->
        </div>


        <!-- Calendario Semanal (Principal) -->
        <div class="calendario-semanal" *ngIf="!isMobileView()">
          <div class="calendar-header">
            <div class="view-toggles">
              <button class="view-btn mobile-hidden" [class.active]="currentView === 'month'"
                (click)="changeToMonthView()">Mes</button>
              <button class="view-btn mobile-hidden" [class.active]="currentView === 'week'"
                (click)="changeView('week')">Semana</button>
              <button class="view-btn" [class.active]="isDayViewActive()" (click)="changeView('day')">Día</button>
              <!-- <button class="view-btn" [class.active]="isTodaySelected()" (click)="goToToday()">Hoy</button> -->
            </div>
            <div class="calendar-nav" *ngIf="currentView !== 'month'">
              <button class="nav-btn" (click)="navigateWeek(-1)" aria-label="Semana anterior">&#8592;</button>
              <button class="nav-btn" (click)="navigateWeek(1)" aria-label="Semana siguiente">&#8594;</button>
              <span class="current-week">{{ getCurrentWeekRange() }}</span>
            </div>
          </div>

          <div class="calendar-grid" [class.day-view]="currentView === 'day'"
            [class.month-view]="currentView === 'month'">
            <div class="time-column">
              <div class="time-header"></div>
              <div class="time-slot" *ngFor="let hour of timeSlots">{{ hour }}</div>
            </div>

            <!-- Vista semanal -->
            <div class="day-column" *ngFor="let day of weekDays; let i = index" [class.current-day]="i === 0"
              [class.hidden]="currentView === 'day'">
              <div class="day-header">
                <span class="day-name">{{ day.name }}</span>
                <span class="day-date">{{ day.date }}</span>
              </div>
              <div class="day-slots">
                <div class="time-slot" *ngFor="let hour of timeSlots" (click)="selectTimeSlot(day, hour)">
                  <div class="current-time-indicator" *ngIf="i === 0 && hour === '13'"></div>
                  <div class="event-indicator" *ngIf="hasEvent(day, hour)"
                    [title]="'Cita con ' + getCoachName(day, hour) + ' (' + getCoachType(day, hour) + ')'">
                    <div class="event-details" *ngIf="hasEvent(day, hour)">
                      <span class="coach-name">{{ getCoachName(day, hour) }}</span>
                      <span class="coach-type">{{ getCoachType(day, hour) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Vista diaria -->
            <div class="day-column single-day" *ngIf="currentView === 'day'">
              <div class="day-header">
                <div class="day-nav">
                  <button class="day-nav-btn" (click)="navigateDay(-1)"
                    [disabled]="selectedDayIndex === 0">&#8592;</button>
                  <div class="day-info">
                    <span class="day-name">{{ selectedDay?.name }}</span>
                    <span class="day-date">{{ selectedDay?.date }}</span>
                  </div>
                  <button class="day-nav-btn" (click)="navigateDay(1)"
                    [disabled]="selectedDayIndex === 6">&#8594;</button>
                </div>
              </div>
              <div class="day-slots">
                <div class="time-slot" *ngFor="let hour of timeSlots" (click)="selectTimeSlot(selectedDay, hour)">
                  <div class="current-time-indicator" *ngIf="hour === '13'"></div>
                  <div class="event-indicator" *ngIf="hasEvent(selectedDay, hour)"
                    [title]="'Cita con ' + getCoachName(selectedDay, hour) + ' (' + getCoachType(selectedDay, hour) + ')'">
                    <div class="event-details" *ngIf="hasEvent(selectedDay, hour)">
                      <span class="coach-name">{{ getCoachName(selectedDay, hour) }}</span>
                      <span class="coach-type">{{ getCoachType(selectedDay, hour) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Vista Mensual -->
            <div class="month-calendar" *ngIf="currentView === 'month'">
              <div class="month-header">
                <button class="nav-btn" (click)="navigateMonth(-1)">&#8592;</button>
                <div class="month-title">{{ currentMonthYear }}</div>
                <button class="nav-btn" (click)="navigateMonth(1)">&#8594;</button>
              </div>

              <div class="calendar-body">
                <div class="weekdays">
                  <div class="weekday" *ngFor="let day of ['D', 'L', 'M', 'M', 'J', 'V', 'S']">{{ day }}</div>
                </div>

                <div class="days-grid">
                  <div class="day-cell" *ngFor="let dayData of miniCalendarDays"
                    [class.other-month]="dayData.isOtherMonth" [class.today]="dayData.isToday"
                    [class.has-event]="dayData.hasEvent" [class.selected]="isSelectedDay(dayData)"
                    (click)="selectMiniCalendarDay(dayData)">
                    <span class="day-number">{{ dayData.day > 0 ? dayData.day : '' }}</span>
                    <div class="event-indicator" *ngIf="dayData.hasEvent">
                      <span class="event-text">●</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="agenda-container">
          <div *ngIf="agenda.length === 0" class="agenda-empty">
            No hay citas programadas
          </div>

          <div class="agenda-day" *ngFor="let day of agenda">
            <div class="agenda-date">
              {{ day.date }}
            </div>

            <div class="agenda-item" *ngFor="let item of day.events" (click)="onAgendaItemClick(day, item)">
              <div class="agenda-time">{{ item.time }}</div>

              <div class="agenda-info">
                <div class="agenda-category">{{ item.category }}</div>
                <div class="agenda-title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Calendario móvil - Vista de día seleccionado -->
        <!--div class="calendario-mobile" *ngIf="isMobileView()">
          <div class="mobile-calendar-header">
            <div class="mobile-day-info">
              <div class="mobile-day-name">{{ getMobileSelectedDayName() }}</div>
              <div class="mobile-day-date">{{ getMobileSelectedDayDate() }}</div>
            </div>
            <div class="mobile-day-nav">
              <button class="mobile-nav-btn" (click)="navigateMobileDay(-1)">&#8592;</button>
              <button class="mobile-nav-btn" (click)="navigateMobileDay(1)">&#8594;</button>
            </div>
          </div>

          <div class="mobile-calendar-grid">
            <div class="mobile-time-slot" *ngFor="let hour of timeSlots"
              (click)="selectTimeSlot(getMobileSelectedDay(), hour)">
              <div class="mobile-hour">{{ hour }}:00</div>
              <div class="mobile-slot-content">
                <div class="mobile-current-time-indicator" *ngIf="hour === '13'"></div>
                <div class="mobile-event-indicator" *ngIf="hasEvent(getMobileSelectedDay(), hour)">
                  <div class="mobile-event-details">
                    <span class="mobile-coach-name">{{ getCoachName(getMobileSelectedDay(), hour) }}</span>
                    <span class="mobile-coach-type">{{ getCoachType(getMobileSelectedDay(), hour) }}</span>
                    <span class="mobile-event-time">{{ hour }}:00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div-->
      </div>
    </div>
  </div>

  <!-- Sección de Academy -->
  <div class="academy-section" *ngIf="cursos.length > 0">
    <div class="section-header">
      <h2>Phoenix Academy</h2>
      <div class="nav-buttons">
        <button class="btn-nav">&#8592;</button>
        <button class="btn-nav">&#8594;</button>
      </div>
    </div>

    <div class="academy-cards">
      <div class="course-card" *ngFor="let curso of cursos">
        <div class="course-stats">
          <span><i>👁️</i> {{ curso.vistas }} vistas</span>
          <span><i>⏱️</i> {{ curso.duracion }} min</span>
          <button class="btn-share"><i>🔗</i></button>
        </div>

        <div class="course-preview">
          <div class="course-image" [style.background-image]="'url(' + curso.imagen + ')'">
            <!-- La imagen se muestra como background-image -->
          </div>
        </div>

        <div class="course-content">
          <h3>{{ curso.titulo }}</h3>
          <div class="course-categories">Educación • Autoconocimiento</div>

          <div class="course-actions">
            <button class="btn-play"><i>▶️</i> Ver</button>
            <button class="btn-save"><i>💾</i> Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="academy-cta">
      <button class="btn-academy">Ver todos los cursos</button>
    </div>
  </div>

  <!-- Sección de Blog -->
  <div class="blog-section" *ngIf="blog.length > 0">
    <h2>Blog</h2>

    <div class="blog-cards">
      <div class="blog-card" *ngFor="let entrada of blog">
        <div class="blog-image">
          <!-- Aquí iría la imagen del blog -->
        </div>

        <div class="blog-card-content">
          <h3>{{ entrada.titulo }}</h3>
          <p>{{ entrada.extracto }}</p>
          <a href="#">Leer más ></a>
        </div>
      </div>
    </div>

    <div class="blog-cta">
      <button class="btn-blog">Ir al blog</button>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="footer-content">
      <a target="_blank" [routerLink]="['/terms-conditions']">Términos y condiciones</a>
      <a target="_blank" [routerLink]="['/privacy-policies']">Política de privacidad</a>
      <a target="_blank" [routerLink]="['/contact-us']">Contacto</a>
    </div>
  </div>
</div>

<!-- Modal de detalles de cita -->
<div class="appointment-modal-overlay" *ngIf="showAppointmentModal" (click)="closeAppointmentModal()">
  <div class="appointment-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Hora experto {{ selectedAppointment?.coach?.name }}</h3>
      <button class="modal-close-btn" (click)="closeAppointmentModal()">×</button>
    </div>

    <div class="modal-content">
      <div class="meeting-info">
        <div class="meeting-time">
          <span class="time-label">Hora experto {{ selectedAppointment?.coach?.name }}</span>
          <span class="time-value">{{ selectedAppointment?.time }}</span>
        </div>

        <div class="meeting-details">
          <div class="detail-item">
            <span class="detail-label">ID de reunión:</span>
            <span class="detail-value">{{ getMeetingId() }}</span>
          </div>
          <!-- <div class="detail-item">
            <span class="detail-label">Código de acceso:</span>
            <span class="detail-value">{{ getAccessCode() }}</span>
          </div> -->
        </div>

        <div class="invitation-message">
          <p>Expertos Phoenix le está invitando a una reunión de Meet programada. Únase a la reunión de Meet con el
            siguiente link.</p>
        </div>

        <div class="meeting-link">
          <div class="meet-icon">📹</div>
          <span class="link-text">{{ getMeetingLink() }}</span>
        </div>

        <div class="action-buttons">
          <button class="btn-join-meeting" (click)="joinMeeting()">
            Unirse a la reunión
          </button>
          <button class="btn-copy-link" (click)="copyMeetingLink()">
            Copiar enlace
          </button>
          <button class="btn-send-email" (click)="sendAppointmentInfoByEmail()">
            📧 Enviar por email
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de preselección Executive -->
<div *ngIf="showExecutiveModal" class="executive-modal-overlay">
  <div class="executive-modal">
    <div class="modal-header">
      <img [src]="getExecutiveModalImageUrl()" alt="Executive Background" class="modal-background-image">
    </div>
    <div class="modal-content">
      <h2 class="modal-title">¡Felicidades {{ getUserFirstName() }}!</h2>
      <p class="modal-description">
        Entre todas las personas inscritas, has sido <strong>preseleccionado</strong> para Executive.
        Agenda tu entrevista y descubre todo lo que tenemos preparado para ti.
      </p>
      <button class="modal-button" (click)="scheduleInterview()">
        AGENDA AQUÍ
      </button>
      <button class="modal-close" (click)="closeExecutiveModal()">
        ×
      </button>
    </div>
  </div>
</div>

<!-- Modal Horas Mentor -->
<div *ngIf="showHoursMentorModal" class="hours-mentor-modal-overlay">
  <div class="hours-mentor-modal" (click)="$event.stopPropagation()">
    <div class="hours-mentor-modal-image-container">
      <img src="assets/img/hours-mentor-modal.jpg" class="hours-mentor-modal-image">
    </div>
    <div class="hours-mentor-modal-content">
      <h4 class="hours-mentor-modal-title">Aún no cuentas con horas de mentor.</h4>
      <p class="hours-mentor-modal-text">Activa tu acompañamiento personalizado pasando al Plan Professional y empieza a
        construir tu siguiente etapa con un experto.</p>
      <div class="hours-mentor-modal-buttons">
        <button class="hours-mentor-modal-button-close" (click)="closeHoursMentorModal()">Cerrar</button>
        <button class="hours-mentor-modal-button-action" (click)="cardClick('mentor')">Ver ahora</button>
      </div>
    </div>
  </div>
</div>

<!-- Botón flotante - Solo visible cuando isCompleteInfo es true -->
<div *ngIf="user?.isCompleteInfo" class="floating-button-container">
  <button class="floating-button" (click)="onFloatingButtonClick()" [title]="getFloatingButtonTooltip()">
    <i class="fas fa-lightbulb"></i>
  </button>
</div>

<!-- Botón de prueba para el modal Executive -->
<!-- <div class="test-button-container">
  <button class="test-button" (click)="testExecutiveModal()" 
          title="Probar modal Executive">
    🧪 Test Modal
  </button>
</div> -->

<!-- Modal de video -->
<app-video-modal [isVisible]="showVideoModal" (closeDialogEvent)="closeVideoModal()">
</app-video-modal>

<!-- Modal de Lista de Espera -->
<div *ngIf="showWaitlistModal" class="waitlist-modal-overlay">
  <div class="waitlist-modal" (click)="$event.stopPropagation()">
    <div class="waitlist-modal-content">
      <div class="modal-header-text">
        <p>Descubre todo lo que Phoenix Professional tiene para ti</p>
      </div>
      <!-- Sección de Video -->
      <div class="video-section">
        <div class="video-container">
          <!-- Usar nuestro componente reutilizable YouTube Player -->
          <div #youtubePlayer>
            <app-youtube-player *ngIf="getProfessionalVideoId()" [videoId]="getProfessionalVideoId()"
              [params]="getVideoParams()"></app-youtube-player>
          </div>

          <!-- Mensaje de error si no hay video ID -->
          <div *ngIf="!getProfessionalVideoId()" class="error-message">
            <p>No se pudo cargar el video profesional</p>
          </div>
        </div>
      </div>

      <!-- Header Text -->
      <div class="modal-header-text">
        <h2>Únete a nuestra lista de espera para convertirte en Phoenix Professional</h2>
        <p>Sé el primero en acceder a todas las increíbles actividades que tenemos para ti</p>
      </div>

      <!-- Formulario -->
      <form class="waitlist-form" (ngSubmit)="submitWaitlistForm()">
        <div class="form-row">
          <div class="form-group">
            <label>Nombre <span class="required">*</span></label>
            <input type="text" [(ngModel)]="waitlistForm.nombre" name="nombre" placeholder="Ingrese nombre" required>
          </div>

          <div class="form-group">
            <label>Apellido <span class="required">*</span></label>
            <input type="text" [(ngModel)]="waitlistForm.apellido" name="apellido" placeholder="Ingrese apellido"
              required>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Teléfono <span class="required">*</span></label>
            <input type="tel" [(ngModel)]="waitlistForm.telefono" name="telefono" placeholder="Ingrese teléfono"
              required>
          </div>

          <div class="form-group">
            <label>Correo electrónico <span class="required">*</span></label>
            <input type="email" [(ngModel)]="waitlistForm.correoElectronico" name="correoElectronico"
              placeholder="Ingrese correo" required>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Provincia <span class="required">*</span></label>
            <select [(ngModel)]="waitlistForm.provincia" name="provincia" (change)="onProvinciaChange()" required>
              <option value="">Ingrese provincia</option>
              <option *ngFor="let provincia of provincias" [value]="provincia">
                {{ provincia }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Distrito <span class="required">*</span></label>
            <select [(ngModel)]="waitlistForm.distrito" name="distrito" [disabled]="!waitlistForm.provincia" required>
              <option value="">Ingrese distrito</option>
              <option *ngFor="let distrito of getDistritosByProvincia()" [value]="distrito">
                {{ distrito }}
              </option>
            </select>
          </div>
        </div>

        <button type="submit" class="register-button" [disabled]="!isWaitlistFormValid() || isSubmittingWaitlist">
          <span *ngIf="!isSubmittingWaitlist">Registrarme</span>
          <span *ngIf="isSubmittingWaitlist">Registrando...</span>
        </button>
      </form>

      <!-- Sección de Beneficios -->
      <div class="benefits-section">
        <h3>Descubre todo lo que Phoenix Professional tiene para ti</h3>
        <div class="benefits-list">
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Sesión grupal mensual para avanzar en comunidad</span>
          </div>
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Mentor digital 24/7 disponible para guiarte en cualquier momento.</span>
          </div>
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Crea tu plan de vida y define objetivos claros con seguimiento.</span>
          </div>
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Acceso completo al directorio de expertos.</span>
          </div>
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Acceso a la Academy con contenidos avanzados.</span>
          </div>
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Acceso a Phoenix Sessions</span>
          </div>
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Rutas de reinvención y herramientas personalizadas para tu progreso.</span>
          </div>
        </div>
      </div>

      <!-- Botón de cerrar -->
      <button class="close-button" (click)="closeWaitlistModal()">
        <span>×</span>
      </button>
    </div>
  </div>
</div>

<!-- Modal Historial de Compras -->
<div *ngIf="showModalPurchaseSummary" class="purchase-summary-modal-overlay">
  <div class="purchase-summary-modal-content" (click)="$event.stopPropagation()">
    <div class="purchase-summary-modal-header">
      <h2 class="title">Resumen de compras Horas Expertos</h2>
    </div>
    <div class="purchase-summary-modal-body">
      <div class="purchase-summary-modal-table-container">
        <table class="purchase-summary-modal-table">
          <thead>
            <tr>
              <th class="sortable" (click)="sortBy('date')">
                <div class="header-content">
                  <span>Fecha de compra</span>
                  <mat-icon class="sort-icon">unfold_more</mat-icon>
                </div>
              </th>
              <th class="sortable" (click)="sortBy('expert')">
                <div class="header-content">
                  <span>Nombre de experto</span>
                  <mat-icon class="sort-icon">unfold_more</mat-icon>
                </div>
              </th>
              <th class="sortable" (click)="sortBy('type')">
                <div class="header-content">
                  <span>Dimensión</span>
                  <mat-icon class="sort-icon">unfold_more</mat-icon>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let purchase of paginatedData; let i = index">
              <tr class="objective-row">
                <td> {{ this.parseDateLineToDash(purchase.date) }} </td>
                <td> {{ purchase.coach.name }} </td>
                <td> {{ purchase.coach.type.name }} </td>
              </tr>
            </ng-container>
          </tbody>
          <tr *ngIf="userAppointments.length === 0">
            <td colspan="8" class="no-data-cell">
              No hemos encontrado compras realizadas
            </td>
          </tr>
        </table>
      </div>

      <!-- Paginación -->
      <div class="pagination-container" *ngIf="totalPages > 1">
        <div class="pagination-info">
          <button class="pagination-btn" [disabled]="currentPage === 1" (click)="previousPage()">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <div class="page-numbers">
            <!-- Primera página siempre visible si hay más de 1 página -->
            <button *ngIf="totalPages > 1" class="page-btn" [class.active]="currentPage === 1" (click)="goToPage(1)">
              1
            </button>

            <!-- Puntos suspensivos antes si la página actual está lejos del inicio -->
            <span *ngIf="currentPage > 3 && totalPages > 5" class="page-dots">...</span>

            <!-- Páginas alrededor de la página actual -->
            <ng-container *ngFor="let page of getVisiblePages()">
              <button *ngIf="page !== 1 && page !== totalPages" class="page-btn" [class.active]="currentPage === page"
                (click)="goToPage(page)">
                {{ page }}
              </button>
            </ng-container>

            <!-- Puntos suspensivos después si la página actual está lejos del final -->
            <span *ngIf="currentPage < totalPages - 2 && totalPages > 5" class="page-dots">...</span>

            <!-- Última página siempre visible si hay más de 1 página y no es la primera -->
            <button *ngIf="totalPages > 1 && totalPages !== 1" class="page-btn"
              [class.active]="currentPage === totalPages" (click)="goToPage(totalPages)">
              {{ totalPages }}
            </button>
          </div>
          <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="nextPage()">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="results-info">
          Mostrando {{ getDisplayedItemsText() }} de {{ userAppointments.length }} resultados
        </div>
      </div>
    </div>
    <div class="purchase-summary-modal-actions">
      <button class="btn-close" (click)="closeModalPurchaseSummary()">
        Salir
      </button>
    </div>
  </div>
</div>